// Utils
import traverse from 'fc-utils/traverse'

export default traverse(['mapModule', 'selectedJobId', Number])
